export default "__VITE_ASSET__99440a03__"